"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.renderSkillsSection = renderSkillsSection;
var _litHtml = require("lit-html");
var _textUtils = require("../../textUtils");
var _SkillsEditDialog = require("./SkillsEditDialog");
var _profileIcons = require("../../icons-svg/profileIcons");
var _texts = require("../../texts");
var _collapsibleSection = require("../shared/collapsibleSection");
var _mutations = require("./mutations");
function renderSkillItem(detail, store, subject, viewerMode, onSaved) {
  if (!detail) return (0, _litHtml.html)``;
  const handleRemove = async event => {
    event.preventDefault();
    if (viewerMode !== 'owner') return;
    const removeRow = {
      name: detail.name,
      publicId: detail.publicId,
      entryNode: detail.entryNode.value,
      status: 'deleted'
    };
    await (0, _mutations.processSkillsMutations)(store, subject, {
      create: [],
      update: [],
      remove: [removeRow]
    });
    if (onSaved) {
      await onSaved();
    }
  };
  return (0, _litHtml.html)`
    <li class="skills__item inline-flex-row" role="listitem">
      <span class="skills__item-label">${(0, _textUtils.strToUpperCase)(detail.name)}</span>
      ${viewerMode === 'owner' ? (0, _litHtml.html)`
            <button
              type="button"
              class="skills__remove-button inline-flex-row"
              aria-label="Remove ${detail.name} skill"
              @click=${handleRemove}
            >
              ${_profileIcons.deleteIcon}
            </button>
          ` : ''}
    </li>
  `;
}
function renderSkillsSectionDefault(store, subject, skills, viewerMode, onSaved) {
  const hasSkills = Array.isArray(skills) && skills.length > 0;
  const isOwner = viewerMode === 'owner';
  return (0, _litHtml.html)`
    <section
      class="profile__section border-lighter profile-section-collapsible profile-section-collapsible--inline-mobile-actions"
      aria-labelledby="skills-heading"
      role="region"
      tabindex="-1"
      data-expanded="false"
    >
      <header class="profile__section-header profile-section-collapsible__header">
        <h2 id="skills-heading">${_texts.skillsHeadingText}</h2>
        <div class="profile-section-collapsible__actions flex-column">
          ${isOwner ? (0, _litHtml.html)`
            <button
              type="button"
              class="profile__action-button profile-action-text flex-center profile-section-collapsible__edit-button"
              aria-label="Add or edit skills"
              @click=${event => (0, _SkillsEditDialog.createSkillsEditDialog)(event, store, subject, skills, viewerMode, onSaved)}
            >
              <span class="profile-section-collapsible__edit-label profile__add-more-content inline-flex-row">
                <span class="profile__add-more-icon inline-flex-row" aria-hidden="true">${_profileIcons.addIcon}</span>
                Add More
              </span>
              <span class="profile-section-collapsible__edit-icon" aria-hidden="true">${_profileIcons.editIcon}</span>
            </button>
          ` : (0, _litHtml.html)``}
          <button
            type="button"
            class="inline-flex-row"
            aria-label="Toggle skills section"
            aria-controls="skills-panel"
            aria-expanded="false"
            @click=${_collapsibleSection.toggleCollapsibleSection}
          >
            <span class="profile-section-collapsible__chevron" aria-hidden="true">⌄</span>
          </button>
        </div>
      </header>
      <div
        id="skills-panel"
        class="profile-section-collapsible__content"
        aria-hidden="true"
      >
        ${hasSkills ? (0, _litHtml.html)`
              <ul class="skills__list flex-column" role="list" aria-label="Professional skills and competencies">
                ${skills.map(detail => renderSkillItem(detail, store, subject, viewerMode, onSaved))}
              </ul>
            ` : (0, _litHtml.html)`<p>No skills added yet.</p>`}
      </div>
    </section>
  `;
}
function renderOwnerEmptySkillsContent(_store, _subject, _skills, _viewerMode, _onSaved) {
  return (0, _litHtml.html)`
      <div class="profile__empty-state-content flex-column-center" role="group" aria-label="Empty skills section">    
        <div class="skills__empty-icon-wrapper">
          <span class="skills__empty-icon inline-flex-row">${_profileIcons.lighteningIcon}</span>
        </div>
        <p class="profile__empty-state-message skills__empty-message">
            No skills added yet.
        </p>
      </div>
  `;
}
function renderOwnerEmptySkillsSection(store, subject, skills, viewerMode, onSaved) {
  return (0, _litHtml.html)`
    <section 
      aria-labelledby="skills-heading" 
      data-profile-section="skills"
      class="profile__section--empty border-lighter rounded-md gap-lg profile-section-collapsible profile-section-collapsible--inline-mobile-actions" 
      role="region"
      tabindex="-1"
      data-expanded="false"
    >
      <header class="profile__section-header profile-section-collapsible__header">
        <h2 id="skills-heading" tabindex="-1">${_texts.skillsHeadingText}</h2>
        <div class="profile-section-collapsible__actions flex-column">
          <button
            type="button"
            class="profile__action-button profile-action-text flex-center profile-section-collapsible__edit-button"
            aria-label="Add skills"
            @click=${event => {
    return (0, _SkillsEditDialog.createSkillsEditDialog)(event, store, subject, skills, viewerMode, onSaved);
  }}
          >
            <span class="profile-section-collapsible__edit-label profile__add-more-content inline-flex-row">
              <span class="profile__add-more-icon inline-flex-row" aria-hidden="true">${_profileIcons.addIcon}</span>
              Add Skills
            </span>
            <span class="profile-section-collapsible__edit-icon" aria-hidden="true">${_profileIcons.editIcon}</span>
          </button>
          <button
            type="button"
            class="inline-flex-row"
            aria-label="Toggle skills section"
            aria-controls="skills-panel"
            aria-expanded="false"
            @click=${_collapsibleSection.toggleCollapsibleSection}
          >
            <span class="profile-section-collapsible__chevron" aria-hidden="true">⌄</span>
          </button>
        </div>
      </header>
      <div id="skills-panel" class="profile-section-collapsible__content" aria-hidden="true">
        ${renderOwnerEmptySkillsContent(store, subject, skills, viewerMode, onSaved)}
      </div>
    </section>
  `;
}
function renderSkillsSection(store, subject, skills, viewerMode, onSaved) {
  const safeSkills = skills || [];
  const hasSkills = Array.isArray(safeSkills) && safeSkills.length > 0;
  const showOwnerEmptySkills = !hasSkills && viewerMode === 'owner';
  const showSection = true;
  return showSection ? (0, _litHtml.html)`
    ${showOwnerEmptySkills ? renderOwnerEmptySkillsSection(store, subject, safeSkills, viewerMode, onSaved) : renderSkillsSectionDefault(store, subject, safeSkills, viewerMode, onSaved)}
  ` : '';
}